import React, { useLayoutEffect, useState } from 'react';
import queryString from 'query-string';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from 'utils';
import { AppBarPayment, Option, SideBar } from '../alf-design';
import { Background, Footer } from 'components/layout';
import { Initial, Summary } from './pages';
import './PaymentLayout.css';

const PaymentLayout = () => {
  const navigate = useNavigate();
  const [policyNumber, setPolicyNumber] = useState(null);
  const [step, setStep] = useState('form');
  const [paymentData, setPaymentData] = useState(null);
  const [openSideBar, setOpenSideBar] = useState(false);
  const { loginWithRedirect } = useAuth0();

  useLayoutEffect(() => {
    document.title = 'One-Time payment for Slide Insurance Policyholders';
    const { ...params } = queryString.parse(location.search);
    if (params?.policyNumber) {
      setPolicyNumber(params?.policyNumber);
    }
  }, [location]);

  const handleLogin = async () => {
    setOpenSideBar(false);
    await loginWithRedirect();
  };

  const handleCreateAccount = () => {
    setOpenSideBar(false);
    window.open(`/create-account`, '_blank');
  };

  const handleLogo = () => {
    setOpenSideBar(false);
    navigate('/payments', { replace: true });
  };

  const handleSideBar = (e) => {
    e.preventDefault();
    setOpenSideBar(!openSideBar);
  };

  return (
    <div className="paymentLayout">
      <SideBar
        open={openSideBar}
        title="Make one-time payment"
        onClose={() => setOpenSideBar(false)}
      >
        <>
          <Option
            alt="Create Account page"
            title="Create Account"
            iconName="questionCircle"
            onClick={handleCreateAccount}
          />
          <Option title="Log In" iconName="userCircle" onClick={handleLogin} />
        </>
      </SideBar>

      <Background>
        <AppBarPayment
          onLogin={handleLogin}
          onCreateAccount={handleCreateAccount}
          onSideBar={handleSideBar}
          onLogo={handleLogo}
          breakpoint="md"
        />
        <main id="main-content" role="main">
          <div aria-hidden={openSideBar}>
            <div>
              {step === 'form' && (
                <Initial
                  policyNumber={policyNumber ?? ''}
                  setStep={setStep}
                  setPaymentData={setPaymentData}
                />
              )}
              {step === 'summary' && <Summary data={paymentData} />}
            </div>
          </div>
        </main>
        <Footer />
      </Background>
    </div>
  );
};

export default PaymentLayout;
